"use client";
import { useEffect, useState } from "react";

// Scroll-spy: the id of the section crossing the upper part of the viewport
// (the preview's `-25% 0px -60% 0px` band). State is only set from the
// observer callback, never synchronously in the effect.
export function useActiveSection(ids: string[]) {
  const initialState: { activeId: string | null } = { activeId: null };
  const [state, setState] = useState(initialState);
  const idsKey = ids.join(",");

  useEffect(() => {
    if (!("IntersectionObserver" in window)) return;
    const targets = idsKey
      .split(",")
      .map((id) => document.getElementById(id))
      .filter((target): target is HTMLElement => target !== null);

    function handleIntersect(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const activeId = entry.target.id;
          setState((state) => ({ ...state, activeId }));
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersect, {
      rootMargin: "-25% 0px -60% 0px",
    });
    targets.forEach((target) => observer.observe(target));
    return () => observer.disconnect();
  }, [idsKey]);

  return state.activeId;
}
